<template>
  <div
    class="premium-upsell"
    data-test="page-premiumupsell"
  >
    <div class="banner">
      <div class="banner-content">
        <h1 class="banner-title">Podcasts only on Luminary</h1>
        <p class="banner-desc">Sign up for Luminary Premium and listen to new podcasts from creators you love and more launching monthly for {{ localPricing.price | amountFilter(localPricing.currency) }} {{ localPricing.price | taxFilter(localPricing.currency) }}.
          <router-link
            target="_blank"
            to="/termsfreetrial"
          >
            Terms apply.
          </router-link>
        </p>
        <router-link
          to="/premium-buy"
          type="primary"
          class="banner-btn el-button el-button--primary"
          data-test="btn-premiumfree">Try
          <span
            v-if="promoMeta.trialPeriod > 1"
            class="line-through">1 month</span> {{ promoMeta.formattedTrialPeriod }} of Premium free</router-link>
      </div>
      <div class="bg-image">
        <img src="../assets/images/premiumheader.png">
      </div>
    </div>
    <div class="premium-perks">
      <h4 class="section-title">
        Premium Perks
      </h4>
      <div class="premium-perks-content-container">
        <div
          v-for="(item, index) in premium_content"
          :key="`perk-item-${index}`"
          class="premium-perks-content"
        >
          <div class="yellow-circle">
            <span>{{ index+1 }}</span>
          </div>
          <h4>{{ item.title }}</h4>
          <p> {{ item.description }} </p>
        </div>
      </div>
    </div>
    <div class="app-price">
      <h4 class="section-title">
        How to listen on luminary
      </h4>
      <price-cards />
    </div>
    <div class="premium-shows">
      <h4 class="section-title">
        Premium Shows
      </h4>
      <h1 class="subtitle">
        Podcasts only on Luminary
      </h1>
      <loader
        v-show="!exclusive_podcasts_loaded"
        :with-margin="true"
        label="Fetching Luminary Exclusives..."
      />
      <podcast-list
        v-if="exclusive_podcasts_loaded"
        :bucket="exclusive_podcasts"
        type="podcast"
      />
    </div>
    <app-download />
  </div>
</template>
<script>
import * as log from 'loglevel';
import PriceCards from '../components/PriceCards';
import PodcastList from '../components/PodcastList';
import PodcastService from '../services/Podcast';
import Loader from '../components/Loader';
import AppDownload from '../components/AppDownload';
import PageMixin from '../shared/pageMixin';

export default {
  name: 'PremiumUpsell',
  components: {
    'price-cards': PriceCards,
    'podcast-list': PodcastList,
    'app-download': AppDownload,
    Loader,
  },
  mixins: [PageMixin],
  data() {
    return {
      pageName: 'Premium Upsell',
      premium_content: [
        { title: 'Luminary Originals', description: ' Get access to the 40+ original ad-free shows we’re launching this year.' },
        { title: 'Uninterrupted Listening', description: 'Ad free Luminary Originals.' },
        { title: 'Your favorites too', description: 'Hundreds of thousands of shows you already listen to and love.' },
        { title: 'Cancel Anytime', description: 'Take a break from Premium anytime.' },
      ],
      podcast_service: new PodcastService(),
      exclusive_podcasts: {
        uuid: null,
        name: null,
        bucket_type: 'podcasts',
        media_size: 'thumbnail',
        items: [],
      },
      exclusive_podcasts_loaded: false,
      // premiumPage: this.$store.getters.loggedIn ? '/premium-buy' : '/signup',
      defaultPrice: this.$store.getters.pricing,
    };
  },
  beforeMount() {
    this.getLuminaryExclusiveShows();
  },
  methods: {
    getLuminaryExclusiveShows() {
      this.podcast_service.getExclusivePodcasts().then((res) => {
        this.exclusive_podcasts.items = res.podcasts || [];
        this.exclusive_podcasts.items = res.podcasts.map(item => ({ ...item, publisher_name: item.description }));
        this.exclusive_podcasts.items_count = res.podcasts.length;
        this.exclusive_podcasts_loaded = true;
      }).catch(error => log.info(error.message));
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";
.premium-upsell {
  .section-title {
    font-size: 20px;
    font-weight: bold;
    font-family: Favorit;
    line-height: 24px;
    text-align: center;
    color: $black;
    text-transform: uppercase;
    margin: 0 0 25px 0;
  }
  .banner {
    width: 100%;
    max-height: 550px;
    background-color: $black;
    display: flex;
    overflow: hidden;
    .banner-content {
      margin: 60px 50px 50px 200px;
      width: 55%;
      .banner-title {
        font-size: 76px;
        margin: 0 0 30px 0;
        max-width: 640px;
        font-family: "ITC Clearface";
        color: #fff;
        line-height: 82px;
        letter-spacing: -1.9px;
      }
      .banner-desc {
        color: #fff;
        font-size: 20px;
        line-height: 28px;
        max-width: 640px;
        margin: 0 0;
        font-family: Favorit-light;
        a {
          color: #fff;
          text-decoration: underline;
        }
      }
      .banner-btn {
        margin: 70px 0 120px 0;
        text-transform: none;
        padding-top: 15px;
        height: 50px;
      }
    }
    .bg-image {
      max-width: 45%;
      max-height: 580px;
    }
  }
  .premium-perks {
    padding: 2% 8%;
    .premium-perks-content-container {
      display: flex;
      .premium-perks-content {
        text-align: center;
        width: 25%;
        padding: 0 20px;
        &:not(:last-child) {
          border-right: 1px solid rgba(17,17,17,0.2);
        }
        .yellow-circle {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background-color: $brand;
          margin: 0 auto;
          span {
            color: $black;
            font-size: 50px;
            font-family: "ITC Clearface";
          }
        }
        h4 {
          font-family: "ITC Clearface" !important;
          font-size: 30px;
          line-height: 34px;
          color: $black;
          margin: 12px 0 !important;
        }
        p {
          line-height: 24px;
          font-size: 18px;
          font-family: Favorit-light;
        }
      }
    }
  }
  .app-price {
    background-color: #F5F4F4;
    padding: 60px 25px 70px 25px;
    .section-title {
      margin-bottom: 40px;
    }
  }
  .premium-shows {
    text-align: center;
    padding: 50px 25px 40px 25px;
    .podcast-list {
      .podcast-card {
        height: 287px;
        width: 287px;
        .podcast-image {
          height: 287px;
        }
        .podcast-content {
          padding-top: 14px;
          text-align: left;

          .podcast-title {
            font-size: 20px;
            line-height: 32px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline;
            white-space: pre-line;
          }
          .publisher-name {
            font-size: 16px;
            line-height: 22px;
            overflow: hidden;
            height: 45px;
            text-overflow: ellipsis;
            margin-top: 5px !important;
            text-align: left !important;
          }
        }

        &:hover {
          .podcast-content {
            .podcast-title {
              border-bottom: 2px solid #00BEDE;
            }
          }
        }
      }
      .flickity-viewport {
       padding-bottom: 140px;
      }
      .flickity-button {
        box-shadow: 0 0 !important;
        top: 35% !important;
        &:nth-of-type(1) {
          left: -50px !important;
        }
        &:nth-of-type(2) {
          right: -50px !important;
        }
      }
    }
    .section-title {
      margin-bottom: 0;
    }
    .subtitle {
      margin: 16px 0 40px 0;
      letter-spacing: -2.01px;
      line-height: 48px;
      font-size: 48px;
      font-family: "ITC Clearface";
      margin-bottom: 64px;
    }
  }
}
@media (max-width: 1200px) {
  .premium-upsell {
    .banner {
      .banner-content {
        margin: 150px 25px 0 50px;
        .banner-title {
          font-size: 50px;
          line-height: 50px;
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .premium-upsell {
    .banner {
      .banner-content {
        margin: 100px 25px 0 50px;
        .banner-title {
          font-size: 50px;
          line-height: 50px;
        }
        .banner-btn {
          margin-top: 25px;
        }
      }
    }
    .premium-perks {
      padding: 2% !important;
      .premium-perks-content-container {
        flex-wrap: wrap;
        .premium-perks-content {
          margin-top: 25px;
          &:nth-child(2) {
            border-right: none;
          }
          width: 50% !important;
          box-sizing: border-box;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .premium-upsell {
    .banner {
      .banner-content {
        margin: 40px 20px;
        width: 100%;
        text-align: center;
        .banner-title {
          max-width: 100% !important;
        }
        .banner-desc {
          font-size: 16px;
          line-height: 22px;
          max-width: 100% !important;
        }
        .banner-btn {
          margin: 0 auto;
          margin-top: 32px;
        }
      }
      .bg-image {
        display: none;
      }
    }
    .app-price {
      padding: 60px 15px 70px 15px;
    }
  }
}
@media (max-width: 576px) {
  .premium-upsell {
    .section-title {
      font-size: 16px;
      margin: 25px 0 15px 0 !important;
    }
    .premium-perks {
      padding: 2% !important;
      .premium-perks-content-container {
        flex-wrap: wrap;
        .premium-perks-content {
          border-right: none !important;
          margin-top: 25px;
          width: 100% !important;
          box-sizing: border-box;
          h4 {
            font-size: 26px;
          }
          p {
            color: $black;
            font-size: 16px;
            font-family: Favorit;
          }
          .yellow-circle {
            width: 46px;
            height: 46px;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
              font-size: 36px;
            }
          }
        }
      }
    }
    .app-price {
      padding-top: 50px;
      .section-title {
        margin: 0 0 !important;
      }
    }
    .premium-shows {
      padding: 0px 25px !important;
      .subtitle {
        font-size: 36px;
      }
      .desc {
        font-size: 18px;
      }
      .podcast-list {
        .podcast-card {
          height: 140px;
          width: 140px;
          .podcast-image {
            height: 140px;
          }
          .podcast-content {
            .podcast-title {
              font-size: 14px;
              line-height: 22px;
              height: 23px;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-top: 6px;
            }
            .publisher-name {
              font-size: 12px;
              line-height: 16px;
              height: 33px;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-top: 4px;
            }
          }
        }
        .flickity-button {
          box-shadow: 0 0 !important;
          top: 35% !important;
          &:nth-of-type(1) {
            left: -50px !important;
          }
          &:nth-of-type(2) {
            right: -50px !important;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/PremiumUpsell.vue